export default class More {
    constructor() {
        this.trigger = $('.list__grid__more')
        this.grids = $('.list__content .list__grid')
    }

    /**
     * Reveal the next grid section
     */
    displayNext(e) {
        let me = $(e.currentTarget)
        let parentGrid = me.parents('.list__content')

        var nextItem;

        if ( me.hasClass("search_list_more") )
        {
            var nextItem = parentGrid.find('.list__grid__item.is-invisible').slice(0,8)
        }
        else
        {
            var nextItem = parentGrid.find('.list__grid__item.is-invisible').slice(0,6)
        }
        

        // let nextItem = parentGrid.find('.list__grid__item.is-invisible').slice(0,8)

        if (nextItem.length) {
            nextItem.removeClass('is-invisible').fadeIn(300)
        }

        if (!parentGrid.find('.list__grid__item.is-invisible:first').length) {
            me.fadeOut(500)
        }
    }

    /**
     * Register event listeners
     */
    registerEvents() {
        $(document).on('click', '.list__grid__more', e => this.displayNext(e))
    }

    /**
     * Initialize class
     */
    init() {
        if (this.trigger.length && this.grids.length) {
            //this.registerEvents()
        }
    }
}
